import { UIView, UIViewController, UIButton, UIControl } from "uikit";
import { DLDB } from "dldb";
import { MIOCoreGetPlatformLanguage } from "mio-core";
import { BookingSummaryViewController } from "./BookingSummaryViewController";

// Extend the global Window interface to include AdyenWeb
declare global {
    interface Window {
        AdyenWeb: {
            AdyenCheckout: any;
            Core: any;
            // Add other properties as needed
        };
    }
}
export class AdyenPaymentViewController extends UIViewController
{
    private rootView: UIView;
    private cancelBtn: UIButton;

    viewDidLoad() {
        super.viewDidLoad();

        this.cancelBtn.addTarget(this, this.onCancel, UIControl.Event.touchUpInside);
    }

    private viewIsLoaded = false;
    viewDidAppear(animated: boolean): void {
        super.viewDidAppear(animated);
        this.viewIsLoaded = true;
        this.updateUI();
    }

    private paymentFields: any = null;
    setPaymentFields( paymentFields: any ) {
        this.paymentFields = paymentFields;
        this.setPaymentValues( paymentFields["ID"], paymentFields["SESSION_DATA"], paymentFields["ENV"], paymentFields["ENV_PUB_KEY"], MIOCoreGetPlatformLanguage(), paymentFields["COUNTRY_CODE"], paymentFields["OK_URL"], paymentFields["KO_URL"] );
    }

    private configuration:any = null;
    setPaymentValues( id:string, sessionData:string, env:string, clientKey:string, language:string, countryCode:string, okURL:string, koURL:string ) {

        this.configuration = {
            locale: navigator.language,
            environment: env, // Change to one of the environment values specified in step 4.
            clientKey: clientKey, // Public key used for client-side authentication: https://docs.adyen.com/development-resources/client-side-authentication
            analytics: {
                enabled: true // Set to false to not send analytics data to Adyen.
            },
            session: {
                id: id,
                sessionData: sessionData
            },
            onPaymentCompleted: (result, component) => {
                console.info(result, component);
                console.info( result[ "resultCode" ], result[ "resultCode" ] === "Authorised" )
                
                if ( result[ "resultCode" ] === "Authorised" ) {
                    this.checkout(true, null);
                    this.timer_fired = false;
                    setTimeout( () => {
                        this.timerFired();
                    }, 4000 );
                }
                else {
                    this.showSummaryViewController(true, "Unkonw error");
                }
            },
            onError: (error, component) => {
                console.error(error.name, error.message, error.stack, component);
                this.showSummaryViewController( false, error.message );
            },
            // Any payment method specific configuration. Find the configuration specific to each payment method:  https://docs.adyen.com/payment-methods
            // For example, this is 3D Secure configuration for cards:
            paymentMethodsConfiguration: {
                card: {
                hasHolderName: true,
                holderNameRequired: true,
                billingAddressRequired: false
                }
            }
        } ;
    }

    private updateUI() {
        if (this.viewIsLoaded == false || this.configuration == null) return;

        window.AdyenWeb.AdyenCheckout(this.configuration).then((checkout) => {
            // Note: Dropin might also be under AdyenWeb
            const DropinConstructor = (window as any).Dropin || (window as any).AdyenWeb.Dropin;
            const cardComponent = new DropinConstructor(checkout).mount('#card-container');
        }).catch((error: any) => {
            console.error('Error initializing Adyen:', error);
        });

    }

    onCancel() {
        this.dismissViewController(true);
    }

    private checkout(ok:boolean, error:string) {
        if (ok) {
            DLDB.shared.checkout( this.paymentFields["OK_URL"] + "/?output=json", (code, res) => {
                let ok = ( code === 200 && res["error"] == null )                
                this.showSummaryViewController(ok, ok ? null : res["error"] );
            } );
        }
        else {
            this.showSummaryViewController(false, error );
        }
    }

    showSummaryViewController( ok:boolean, error:string){
        if (this.timer_fired) {
            const vc = BookingSummaryViewController.newInstance( ok );
            //TODO: Show the error
            this.presentViewController(vc, true);
        }
    }

    private timer_fired: boolean = false;
    private timerFired() {
        this.timer_fired = true;
        this.showSummaryViewController( true, null );
    }
}